<template>
  <article class="table--scroll">
    <header>
      <router-link :to="link()" v-if="!routerView">
        <h1>{{ entry['title_' + locale] || entry.title }}</h1>
      </router-link>
      <h1 v-if="routerView">{{ entry['title_' + locale] || entry.title }}</h1>
      <span v-if="entry.author"> {{ $t('ui.content.by_author') }} </span>
      <address v-if="entry.author">
        <span>{{ entry.author }}</span>
      </address>
      <span v-if="entry.created_at"> {{ $t('ui.content.on_date') }} </span>
      <time v-if="entry.created_at" :datetime="new Date(entry.created_at)" pubdate title="">{{
        entry.created_at | Date
      }}</time>
    </header>
    <router-view v-if="routerView" />
    <component v-else-if="component" :is="component" />
  </article>
</template>

<script>
import urljoin from 'url-join';
import { urlify } from '../util';
import { locale } from '../locale';
import MarkdownText from './MarkdownText.vue';

export default {
  name: 'StandardEntry',
  components: { MarkdownText },
  props: {
    entry: {
      type: Object,
      required: true,
    },
    routerView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({ locale, component: null }),
  methods: {
    link() {
      const { title } = this.$route.params;
      if (title) return '';
      const date = new Date(this.entry.created_at);
      return urljoin(
        this.$route.path,
        date.getFullYear().toString(),
        (date.getMonth() + 1).toString(),
        date.getDate().toString(),
        urlify(this.entry.title),
      );
    },
  },
  async created() {
    if (this.routerView) return;
    const path = this.entry.path.replace('src/posts/', '');
    this.component = (await import(`../posts/${path}`)).vue.component;
  },
  watch: {
    async $route(to, from) {
      if (this.routerView) return;
      const path = this.entry.path.replace('src/posts/', '');
      this.component = (await import(`../posts/${path}`)).vue.component;
    },
  },
  metaInfo() {
    return {
      title: this.entry.title,
      meta: [
        // TODO: Add twitter meta properties. See https://developer.twitter.com/en/docs/tweets/optimize-with-cards/overview/markup
        // { property: 'og:url', content: `${this.$route.path}` },
        { property: 'og:type', content: 'article' },
        { property: 'og:title', content: this.entry.title },
        { property: 'og:description', content: this.entry.content },
        { property: 'og:image', content: this.entry.imageUrl },
      ],
    };
  },
};
</script>

<style scoped></style>
